// 铺货查询进度处理

import { publishGoodsResult, prodDistributorDetail } from "@/servers/prod/center";

const initData = () => {
  return {
    // 进度条接口返回数据
    publishSpeedResult: {
      finished: false,
      result: {
        total: 1,
        completions: 0,
        success: 0,
        failure: 0
      }
    },
    percentage: 0,
    timer: null,
    publishType: '',
    resultVisible: false,
    isForceStop: false
  }
}
/** 
 * s_goods: 供销商端商品资料
 * s_display: 供销商端分校小店商品资料
 * s_log: 供销商端商品日志中的铺货日志
 * d_goods: 分销商端商品资料
 * d_log: 分销商端商品日志的铺货日志
 * d_distributor: 分销商端分销商品
 * d_display: 分销商端供销商展架
 * s_updateLog: 供销商端的商品日志中的更新店铺商品
 * d_updateLog: 分销商端的商品日志中的更新店铺商品
 * d_shopGoods: 分销商店铺商品
 * s_shopGoods: 供销商店铺商品
 * s_shopGoods: 供销商裂变商品铺货
 * d_shopGoods: 分销商裂变商品铺货
 * drawer_batch_update_platInfo 批量下架（）
*/
const queryPublishSpeed = {
  state: () => ({
    s_goods: initData(),
    s_display: initData(),
    s_log: initData(),
    d_goods: initData(),
    d_log: initData(),
    s_taskCenterId: initData(),
    d_taskCenterId: initData(),
    d_distributor: initData(),
    d_display: initData(),
    s_updateLog: initData(),
    d_updateLog: initData(),
    drawer_batch_update_platInfo: initData(),
    currentPage: 's_goods',
    rePublishRowData: null,
    displayRePublishRowData: null,
    distributorDetailData: null,
    log_activeName: 'onShelvesLog', // 商品日志激活的tab
    d_shopGoods: initData(),
    s_shopGoods: initData(),
  }),
 
  mutations: {
    setResult (state, data) {
      state[state.currentPage].publishSpeedResult = data;
    },
    // 设置进度
    setPercentage(state, data) {
      state[state.currentPage].percentage = data;
    },
    setTimer(state, data) {
      state[state.currentPage].timer = data
    },
    setPublishType(state, data) {
      state[state.currentPage].publishType = data
    },
    setResultVisible(state, data) {
      state[state.currentPage].resultVisible = data
    },
    setIsForceStop(state, data) {
      state[state.currentPage].isForceStop = data
    },
    setCurrentPage(state, data) {
      state.currentPage = data
    },
    setRePublish(state, data) {
      state.rePublishRowData = data
    },
    setDisplayRePublish(state, data) {
      state.displayRePublishRowData = data
    },
    setDistributor(state, data) {
      state.distributorDetailData = data
    },
    setActiveName(state, data) {
      state.log_activeName = data
    }
  },
  actions: {
    async setDistributorDetail({commit}, payload) {
      const res = await prodDistributorDetail(payload);
      commit('setDistributor', res);
    },
    setRePublishRowData({commit}, payload) {
      commit('setRePublish',payload.rowData)
    },
    clearRePublishRowData({commit}) {
      commit('setRePublish', null)
    },
    setDisplayRePublishRowData({commit}, payload) {
      commit('setDisplayRePublish',payload.rowData)
    },
    clearDisplayRePublishRowData({commit}) {
      commit('setDisplayRePublish', null)
    },
    // 计算进度条
    calculation_progress({commit, state},{total,percentageVal}) {
			let tt = 1500+(total*200)
			let x = 1, y = 50/x, t= tt/y;
			let time = setInterval(()=> {
      if(state[state.currentPage].percentage >= percentageVal) {
        clearInterval(time)
      }else {
        commit('setPercentage',state[state.currentPage].percentage+x)
      }
			}, t)
		},
    // 发起进度条
    publishSpeed({commit,state,dispatch},payload) {
      commit('setIsForceStop',false);
      commit('setPercentage', 0)
      commit('setPublishType', payload.publishType)
      commit('setResultVisible', payload.resultVisible)
      dispatch('fetch_queryPublishSpeed', payload)
    },
    // 进度条进度查询（循环调用）
    async fetch_queryPublishSpeed({commit, state, dispatch},payload) {
      if(state[state.currentPage].isForceStop) return;

      let url = '/item/platform/queryPublishSpeed';
      let params = { taskTypeEnum: payload.publishType };
      if (payload.batchTaskId) {
        const urlConfig = {
          'OFF_SALE_ITEM': { url: '/item/platform/queryOffSaleSpeed' },
          'PIECE_ITEM|fxg': { url: '/item/platform/fxgPublishTaskProgress', paramKey: 'taskBatchId' },
          'BATCH_EDIT_ITEM': { url: '/item/platform/queryPublishSpeedV2', paramKey: 'taskBatchId' },
        };
        const key = `${payload.publishType}|${payload.platform}`;
        const config = urlConfig[key] || urlConfig[payload.publishType];
        const paramKey = config?.paramKey || 'batchTaskId'
        url = config?.url || '/taskScheduling/queryTaskSpeed';
        params = {
          taskTypeEnum: payload.publishType,
          [paramKey]: payload.batchTaskId,
        };
      }
      const res = await publishGoodsResult(params, url);
      commit('setResult', res);
      let { total = 0, completions = 0, progressCompletions = 0, progressTotal = 0 } = res.result || {};
      // /taskScheduling/queryTaskSpeed 接口做了更细分颗粒的进度优化

      if(url === '/taskScheduling/queryTaskSpeed') {
        total = progressTotal;
        completions = progressCompletions;
      }
      if (total > 0) {
        if (total <= 1) {
          dispatch('calculation_progress', { total, percentageVal: 96 });
        } else if (completions <= 1) {
          const percentageVal = Math.max(1, Math.round(100 / total));
          dispatch('calculation_progress', { total, percentageVal });
        } else {
          if (completions >= total && res.finished === false) {
            commit('setPercentage', 96);
          } else {
            const percentage = Math.min(100, Number(((completions / total) * 100).toFixed(2)));
            commit('setPercentage', percentage);
          }
        }
      }
      if(res.finished){
        clearTimeout(state[state.currentPage].timer);
      } else {
        commit('setTimer', setTimeout(async () => {
          dispatch('fetch_queryPublishSpeed', payload)
        },800))
      }
    },
    clearPercentage({commit}) {
      commit("setPercentage", 0)
    },
    clearPublishSpeedResult({commit}) {
      commit('setResult', {
        finished: false,
        result: {
          total: 1,
          completions: 0,
          success: 0,
          failure: 0
        }
      },);
    }
  },
  getters: {
    speedResult(state) {
      return (pageId) => state[pageId].publishSpeedResult
    },
    speedPublishType(state) {
      return (pageId) => state[pageId].publishType
    },
    speedPercentage(state) {
      return (pageId) => state[(pageId)].percentage
    },
    speedResultVisible(state) {
      return (pageId)=> state[(pageId)].resultVisible
    },
    prodRePublishRowData(state) {
      return state.rePublishRowData
    },
    displayRePublishData(state) {
      return state.displayRePublishRowData
    },
    speedCurrentPage(state) {
      return state.currentPage
    },
    distributorDetail(state) {
      return state.distributorDetailData
    },
    getLogActiveName(state) {
      return state.log_activeName
    }
  }
}

export default queryPublishSpeed
